import httpManager from "@/app/shared/utils/httpManager";

/**
 *
 * @param {Object} body
 * @returns {Promise<Object>} chatbotsList
 */

export async function createChatbot(body) {
  const response = await httpManager.post(`/chatbots/`, body);
  return response.data;
}
